module.exports = __webpack_public_path__ + "img/MorrisN.e5619e7d.jpg";